export const ACCEPTED_IMAGE_TYPES = '.jpeg, .png, .gif,.svg , .webp';
export const LINK_TEXT_PLACEHOLDER =
  'Ex :https://www.cegedim-business-services.com/';
export const TEAMSRH4U_WEBPAGE =
  'https://teamsrh4u.com/actualites-offres/Pages/results.aspx?esrhcid=';
